import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { bootstrapDensity } from "@/lib/useDensity";

// Apply the persisted UI density on the <html> tag *before* React paints
// so users who chose "compact" never see a flicker of comfortable spacing.
bootstrapDensity();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register the Web Push service worker once the page is idle. We don't
// request notification permission here — that only happens when the
// user toggles "Get phone alerts" ON inside Profile.
if ("serviceWorker" in navigator && window.isSecureContext) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch((err) => console.warn("[sw] registration failed:", err?.message || err));
  });
}
